import React, { useState } from 'react';
import styled from 'styled-components';
import CompleteTheLook from '../completeTheLook/CompleteTheLook';
import useYouMayAlsoNeed from './hooks/useYouMayAlsoNeed';
import Product from './Product';

const Wrapper = styled.div`
  margin-top: 15px;
  padding: 0px 40px 40px;

  .product-container {
    max-width: 220px;
    margin: 0 auto;
  }
`;

function YouMayAlsoNeed({
  sizeId,
  slug,
  source,
  toggleCart,
  productData,
  setChangeFeaturedFabrics
}) {
  const [totalCompleteTheLook, setTotalCompleteTheLook] = useState(0);
  const { loading, error, data } = useYouMayAlsoNeed({
    sizeId: parseInt(sizeId),
    slug: slug
  });

  if (loading) return ``;
  if (error) return ``;

  const shouldShowTitle = data?.productBySlug || totalCompleteTheLook > 0;

  return (
    <Wrapper>
      {shouldShowTitle && <Title>You May Also Need</Title>}

      <CompleteTheLook
        source={source}
        origin="you_may_also_need"
        emptyTitle
        onCompleted={completeTheLookData => {
          const total = completeTheLookData?.completeTheLook?.length;
          if (completeTheLookData.completeTheLook.length > 0) {
            setTotalCompleteTheLook(total);
          }
        }}
        frameId={productData.frame?.id}
        setChangeFeaturedFabrics={setChangeFeaturedFabrics}
        productSku={productData.sku}
      />
      {data && (
        <div className="product-container">
          <Product
            product={data.productBySlug}
            source={source}
            toggleCart={toggleCart}
          />
        </div>
      )}
    </Wrapper>
  );
}

export default YouMayAlsoNeed;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.charcoal};
  opacity: 0.9;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;

  .step {
    color: ${({ theme }) => theme.colors.charcoal};
  }

  @media (max-width: 992px) {
    font-size: 30px;
  }
`;
